export const pSingleton = (fn) => {
  let runningPromise;

  return function wrappedPromise(...args) {
    if (runningPromise) return runningPromise;

    runningPromise = fn.apply(this, args).finally(() => {
      runningPromise = undefined;
    });

    return runningPromise;
  };
};
